// redux/specialist-slices/appointments.slice.js
import { asyncThunkWrapper } from "../thunkHandler";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { BASEURI, headers } from "../../utils/helper";






// Retrieve all appointments for specialist
export const handleRetrieveMembers = createAsyncThunk(
  "retrieveAll",
  async (data, thunkAPI) => {
    const params = {
      limit: data?.limit || 10,
      currentPage: data?.currentPage || null,
    };

    return asyncThunkWrapper(
      {
        params,
        method: "GET",
        headers: headers(),
        url: `${BASEURI}/specialist/appointment-members/retrieve-all`,
      },
      thunkAPI,
      {
        toast: false,
      }
    );
  }
);

//retrive particular memmber appointments 
export const handleRetrieveMemberAppointmentsDetails = createAsyncThunk(
  "retrieveAll",
  async (data, thunkAPI) => {
    const params = {
      memberId: data?.memberId || "pending",
      limit: data?.limit || 10,
      currentPage: data?.currentPage || null,
      date: data?.date || null,
      status: data?.status || null,
    };

    return asyncThunkWrapper(
      {
        params,
        method: "GET",
        headers: headers(),
        url: `${BASEURI}/specialist/appointment-members/details/retrieve`,
      },
      thunkAPI,
      {
        toast: false,
      }
    );
  }
);